var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showEdit
    ? _c("div", { staticClass: "edit_nav_alias" }, [
        _c(
          "div",
          { staticClass: "edit_box" },
          [
            _c("p", { staticClass: "title" }, [_vm._v("自定义导航")]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c("el-input", {
              attrs: { size: "small" },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.confirm($event)
                }
              },
              model: {
                value: _vm.newConfig.menuName,
                callback: function($$v) {
                  _vm.$set(_vm.newConfig, "menuName", $$v)
                },
                expression: "newConfig.menuName"
              }
            }),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "menu_group" },
              [
                _c(
                  "el-button",
                  { attrs: { size: "small" }, on: { click: _vm.cancel } },
                  [_vm._v("取消")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { size: "small", type: "primary" },
                    on: { click: _vm.confirm }
                  },
                  [_vm._v("确认")]
                )
              ],
              1
            )
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "item" }, [
      _c("span", [_vm._v("*")]),
      _vm._v(" "),
      _c("span", [_vm._v("名称")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e61360b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e61360b2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/editNavAlias.vue
// module id = null
// module chunks = 